import React, { useContext, useEffect, useReducer, useState } from "react";
import Dialog from "@material-ui/core/Dialog";

import {
    createStyles,
    Grid,
    IconButton,
    makeStyles,
    Typography,

} from "@material-ui/core";
import tableIcons, { options } from "components/universal/table_attributes";
import MaterialTable from "material-table";
import { ToastMessageContext } from "lib/contexts/message_context";




const useStyles = makeStyles((theme) =>
    createStyles({
        modal: {
            "& .MuiDialog-paperWidthSm": {
                minWidth: "750px",
                // height: "110vh"
            },
        },
        container: {
            // minWidth: "1200px",
            // minHeight: "400px",
            padding: "50px",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden !important"
        },

        popupTitle: {
            fontSize: "20px",
            lineHeight: "28px",
            position: "absolute",
            top: "19px",
            bottom: "15px",
            left: "25px",
        },



    })
);


export default function History(props) {
    const { handleClose, currentSelection } = props
    const classes = useStyles();
    const message = useContext(ToastMessageContext);
    const tableOptions = {
        ...options,
        paging: false,
        search: false,
        toolbar: false,
        header: false,
        rowStyle: {
            height: '42px'
        }
    };




    return (
        <div>
            <Dialog
                open={true}
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={classes.modal}
            >
                <div className={classes.container}>
                    <Typography
                        variant="body1"
                        color="primary"
                        style={{ marginBottom: "20px" }}
                        className={classes.popupTitle}
                    >
                        {currentSelection?.name}
                    </Typography>

                    <Grid item xs={12} style={{ marginTop: "10px", }}>
                        <MaterialTable
                            style={{
                                boxShadow: "0px 1px 3px #00000033",
                                borderRadius: "4px",
                                width: "650px",
                                // minWidth: "500px"
                            }}

                            columns={[

                                {
                                    title: 'title', field: 'title',
                                    headerStyle: {
                                        textAlign: 'left',
                                        width: '25%',
                                        paddingLeft: '22px'

                                    },

                                    cellStyle: {
                                        textAlign: 'left',
                                        width: '25%',
                                        paddingLeft: '22px',
                                        fontWeight: 600
                                    }
                                },
                                {
                                    title: 'value', field: 'value', width: '60%', headerStyle: {
                                        textAlign: 'left',
                                        width: '75%'
                                    },

                                    cellStyle: {
                                        textAlign: 'left',
                                        width: '75%'
                                    }
                                },


                            ]}
                            data={[
                                {
                                    title: 'Authorities', value: currentSelection?.approval_scope?.authorities.length > 0 ? currentSelection?.approval_scope?.authorities.map((item, index) => {
                                        return (
                                            <span> {item}{index < currentSelection?.approval_scope?.authorities.length - 1 ? ", " : ""}</span>

                                        )
                                    }) : "- "
                                },
                                {
                                    title: 'Customers', value: currentSelection?.approval_scope?.customers.length > 0 ? currentSelection?.approval_scope?.customers.map((item, index) => {
                                        return (
                                            <span> {item}{index < currentSelection?.approval_scope?.customers.length - 1 ? ", " : ""}</span>

                                        )
                                    }) : " -"
                                },
                                {
                                    title: 'Scopes', value: currentSelection?.approval_scope?.scopes.length > 0 ? currentSelection?.approval_scope?.scopes.map((item, index) => {
                                        return (
                                            <span> {item}{index < currentSelection?.approval_scope?.scopes.length - 1 ? ", " : ""}</span>

                                        )
                                    }) : "- "
                                },
                                {
                                    title: 'Limitations', value: currentSelection?.approval_scope?.limitations.length > 0 ? currentSelection?.approval_scope?.limitations.map((item, index) => {
                                        return (
                                            <span> {item}{index < currentSelection?.approval_scope?.limitations.length - 1 ? ", " : ""}</span>

                                        )
                                    }) : "- "
                                },

                            ]}
                            options={tableOptions}
                        />
                    </Grid>
                </div>
            </Dialog>

        </div>
    )
}
